import { Link } from 'react-router'

/** The thank-you from the printed program, and the small print. */
export function FestivalFooter() {
	return (
		<footer className="hk-footer">
			<div className="hk-container">
				<p className="hk-footer-thanks">
					Takk til alle vertane på Vorrå som stiller husa sine til disposisjon,
					og til alle som kjem og fyller romma med musikk.
				</p>
				<div className="hk-footer-meta">
					<p>
						Vorrå Huskonsert Festival · org.nr 937 219 113 · Hasselvegen 6, 4265
						Håvik
					</p>
					<nav aria-label="Meir informasjon">
						<Link to="/tos">Vilkår</Link>
						<Link to="/presse">Presse</Link>
						<a href="#hjelp">Kontakt</a>
					</nav>
				</div>
			</div>
		</footer>
	)
}
